<script setup>
import { useTemplateStore } from "@/stores/template";

import { useWebsiteStore } from "@/stores/website";
import { useUserStore } from "@/stores/user";
import { useActiveDeviceRenderStore } from "@/stores/activeDeviceRender";
import BaseLayout from "@/layouts/BaseLayout.vue";
import { useRoute, useRouter } from "vue-router";
import { onMounted } from "vue";
import AddPagesModal from "@/views/explore/AddPagesModal.vue";
import ScanAgainModal from "@/views/dashboard/ScanAgainModal.vue";

import("@/views/account/DashboardView.vue");
import("@/views/account/Subscription.vue");

import("@/views/sites/NewSiteView.vue");
import("@/views/dashboard/DashboardView.vue");
import("@/views/explore/LandingPagesView.vue");
import("@/views/explore/Timeline.vue");
import("@/views/integrity/Summary.vue");
import("@/views/spelling/Summary.vue");
import("@/views/spelling/GrammarView.vue");

import("@/views/layout_issues/Summary.vue");
import("@/views/layout_issues/LayoutIssues.vue");

import("@/views/technical/Summary.vue");
import("@/views/technical/BrokenImages.vue");
import("@/views/technical/MissingImageAltTags.vue");
import("@/views/technical/BrokenLinks.vue");
import("@/views/technical/BrokenResources.vue");
import("@/views/technical/MissingTitles.vue");
import("@/views/technical/MissingFavicon.vue");
import("@/views/technical/MissingDescriptions.vue");
import("@/views/technical/InternalRedirects.vue");
import("@/views/technical/ConsoleErrors.vue");

import("@/views/ai/Summary.vue");
import("@/views/ai/TrackedPrompts.vue");

import("@/views/settings/Settings.vue");

useActiveDeviceRenderStore()
const websiteStore = useWebsiteStore();
const userStore = useUserStore();

const router = useRouter();
const route = useRoute();
const props = defineProps({
  prefix: String,
});
const store = useTemplateStore();
// Set default elements for this layout
store.setLayout({
  header: true,
  sidebar: true,
  sideOverlay: true,
  footer: true,
});

// Set various template options for this layout variationse
store.headerStyle({mode: "light"});
store.mainContent({mode: "narrow"});

// on mounted
onMounted(() => {
  new bootstrap.Modal(document.getElementById('modal-add-more-pages'))
  new bootstrap.Modal(document.getElementById('modal-scan-again'), {})
})
</script>

<template>
      <add-pages-modal ref="addPagesModal"></add-pages-modal>
  <scan-again-modal></scan-again-modal>

  <div v-if="!((websiteStore.loaded || route.meta.sidebar === 'user') && userStore.loaded)">
    <div
        style="position: fixed; left:0;top:0;width:100%;height:100%;display:flex;justify-content: center;align-items:center">
      <div class="spinner-border text-primary">
        <span class="sr-only">Loading..</span>
      </div>
    </div>
    <div style="display:none">
      w{{websiteStore.loaded}}
      u{{userStore.loaded}}
    </div>
  </div>
  <BaseLayout v-else>

    <!-- Side Overlay Content -->
    <!-- Using the available v-slot, we can override the default Side Overlay content from layouts/partials/SideOvelay.vue -->
    <template #side-overlay-content>
      <div class="content-side">
        <p>Side Overlay content..</p>
      </div>
    </template>
    <!-- END Side Overlay Content -->

  </BaseLayout>
</template>
